const env = require("../../config.js").default;

const INDEX_DB_NAME = env.PORTAL_NAME;
const INDEX_DB_VERSION = 3;
const DEFAULT_TTL = 60 * 24 //minuti

const defaultDBOpenRequest = indexedDB.open(INDEX_DB_NAME, INDEX_DB_VERSION);
var defaultDB = null;


/* Connessione - START*/
defaultDBOpenRequest.onupgradeneeded = function (e) {
    defaultDB = e.target.result;
    console.debug('running onupgradeneeded');
    defaultDBUpgrade(e, defaultDBOpenRequest);
};
defaultDBOpenRequest.onsuccess = function (e) {
    console.debug('running onsuccess');
    defaultDB = e.target.result;
};
defaultDBOpenRequest.onerror = function (e) {
    console.debug('onerror!');
    console.dir(e);
};

/* Gestione struttura */
function defaultDBUpgrade(e, rq) {
    var objectStore = null;
    var objectStore2 = null;

    try {
        defaultDB.deleteObjectStore('fetchCache');
    } catch (e) {
        console.debug("tabella non presente")
    }
    try {
        defaultDB.deleteObjectStore('UX');
    } catch (e) {
        console.debug("tabella non presente")
    }

    objectStore = defaultDB.createObjectStore('fetchCache', { keyPath: 'request' });
    objectStore.createIndex("timestamp", "timestamp");
    objectStore.createIndex("contentType", "contentType");
    objectStore2 = defaultDB.createObjectStore('UX', { keyPath: 'pagina' });
    /*if (e.oldVersion < 2) {
    }*/
}
/* Connessione - END*/

/***********************************************************************************/
/***********************************************************************************/
/***********************************************************************************/

/* CACHE - START */
export async function getCacheDB(key, ttl = DEFAULT_TTL) {
    if (ttl === null)
        ttl = DEFAULT_TTL;

    return new Promise(function (resolve, reject) {
        const transaction = defaultDB.transaction(["fetchCache"], "readwrite");
        const objectStore = transaction.objectStore("fetchCache");
        const request = objectStore.get(key);
        console.debug(request)
        request.onerror = (event) => {
            console.log("cache error")
            // Handle errors!
            resolve(null);
        };
        request.onsuccess = (event) => {
            if (request.result !== undefined && request.result.value !== undefined) {
                let now = new Date().getTime();
                let scadenza = request.result.timestamp + (ttl * 60 * 1000);
                if (scadenza < now) {
                    console.debug("conteuto " + request.result.request + " scaduto in cache. Elimino");
                    objectStore.delete(key);
                    resolve(null);
                } else {
                    console.debug("conteuto " + request.result.request + " recuperato da cache");
                    resolve(request.result.value);
                }
            } else {
                resolve(null);
            }
        };
    });
}

export function refreshCacheDB(contentType, upperTimestamp) {
    const transaction = defaultDB.transaction(["fetchCache"], "readwrite");
    const objectStore = transaction.objectStore("fetchCache");
    const timestampIndex = objectStore.index("timestamp");
    const getAllRequest = timestampIndex.getAll(IDBKeyRange.upperBound(upperTimestamp));
    const CONTENT_TIME_REMOVE_ALWAYS = ["all"];

    getAllRequest.onsuccess = (event) => {
        let contentTypeToSearch = CONTENT_TIME_REMOVE_ALWAYS;
        contentTypeToSearch.push(contentType);
        for (let i in getAllRequest.result) {
            const key = getAllRequest.result[i].request;
            if (getAllRequest.result[i].contentType.some(r => contentTypeToSearch.includes(r))) {
                console.debug("Elimino risorsa " + key + " perchè più vecchia dell'ultimo aggiornamento");
                objectStore.delete(key);
            }
        }
    }
}

export function addCacheDB(cacheData) {
    const transaction = defaultDB.transaction(["fetchCache"], "readwrite");
    const objectStore = transaction.objectStore("fetchCache");
    const request = objectStore.add(cacheData);
    request.onsuccess = (event) => {
        // event.target.result === cacheData.ssn;
    };

}

export function emptyCacheDB() {
    const transaction = defaultDB.transaction(["fetchCache"], "readwrite");
    const objectStore = transaction.objectStore("fetchCache");
    const request = objectStore.clear();
    request.onsuccess = (event) => {
        console.debug("Svuotata cache")
        // event.target.result === cacheData.ssn;
    };

}

export function deleteRecord(record) {
    const transaction = defaultDB.transaction(["fetchCache"], "readwrite");
    const objectStore = transaction.objectStore("fetchCache");
    var index = objectStore.index("indexes");
    var request = index.get(record);

    request.onsuccess = function (event) {
        var recordToDelete = event.target.result;
        if (recordToDelete) {
            var deleteRequest = objectStore.delete(recordToDelete)
            deleteRequest.onsuccess = function () {
                console.log('Record eliminato con successo:', recordToDelete);
            };
            deleteRequest.onerror = function (event) {
                console.error('Errore durante l\'eliminazione del record:', event.target.error);
            }
        }
        else {
            console.log('Nessun record trovato con il valore:', recordToDelete);
        }
    }
    request.onerror = function (event) {
        console.error('Errore durante la ricerca del record:', event.target.error);
    };
    transaction.oncomplete = function () {
        console.log('Operazione completata');
    };
}
/* CACHE - END */


/***********************************************************************************/
/***********************************************************************************/
/***********************************************************************************/

/* Gestione UX */

/* GET RECORD */
export function getUXPageRecord(key) {
    return new Promise((resolve, reject) => {
        const transaction = defaultDB.transaction(["UX"], "readwrite");
        const objectStore = transaction.objectStore("UX");
        const pagina = objectStore.get(key);
        pagina.onerror = (event) => {
            console.error("UX page error");
            // Handle errors!
            resolve(null);
        };
        pagina.onsuccess = (event) => {
            if (pagina !== undefined) {
                console.debug("UX page FETCHED CORRECTLY");
                console.debug(pagina);
                resolve(pagina);
            }
        };
    });
}

/* GET SEZIONE */
export function getUXPageSectionValue(key, sezione) {
    return new Promise((resolve, reject) => {
        getUXPageRecord(key).then(resultPagina =>{
            if (resultPagina["result"] !== undefined){
                var resultSezione = resultPagina["result"][sezione]
                    console.debug("UX section FETCHED CORRECTLY");
                    console.debug(resultSezione);
                    resolve(resultSezione);                    
            }else{
                console.debug("UX empty");
                resolve();
                }      
            }
        )
    })
}

/* GET COMPONENTE */
export function getUXPageComponentValue(key, section, component){
    return new Promise((resolve, reject) => {
        getUXPageSectionValue(key, section).then(resultSection =>{
            if(resultSection !== undefined){
                if (resultSection[component] !== undefined){
                    var resultComponent = resultSection[component];
                    console.debug("UX component fetched correctly");
                    console.debug(resultComponent);
                    resolve(resultComponent);
                }else{
                    console.debug("UX name component empty");
                    resolve();               
                }
            }else{
                console.debug("UX empty");
                resolve();
            }
        })
    })
}

/* ADD COMPONENTE */


/* ADD SEZIONE */



/* ADD RECORD */
export function addUXPageRecord(cacheData) {
    const transaction = defaultDB.transaction(["UX"], "readwrite");
    const objectStore = transaction.objectStore("UX");
        const request = objectStore.put(cacheData);
        request.onsuccess = (event) => {
            console.debug(cacheData['pagina'] + " AGGIUNTO a cache");
            // event.target.result === cacheData.ssn;
        };
}


/* DELETE WHOLE UX */
export function emptyUX() {
    const transaction = defaultDB.transaction(["UX"], "readwrite");
    const objectStore = transaction.objectStore("UX");
    const request = objectStore.clear();
    request.onsuccess = (event) => {
        console.debug("Svuotata UX")
        // event.target.result === cacheData.ssn;
    };
}

